import EditProductProfile from './EditProductProfile';

export default EditProductProfile;
